import { lightColors } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { FlashSaleCampaignName } from 'src/common/enums/campaigns';
import { useGetUserQuery } from 'src/common/slices';
import { useGetInfluencersCampaignsQuery } from 'src/features/admin/campaigns/campaigns.slice';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useInfluencerConfigs } from '../../influencers/hooks/use-influencer-additional-configs';
import { useInfluencerSubscriptionCampaign } from '../../influencers/hooks/use-influencer-campaign';
import { SubscribeButton } from '../subscribe-button';
import { StyledBar, StyledCopyWrapper, StyledWrapRow } from './top-bar.styles';
export const CertificationsFlashSaleTopBar: FC<{
  hideCTA?: boolean;
  isEmbedded?: boolean;
  isPremium?: boolean;
}> = ({
  hideCTA,
  isEmbedded,
  isPremium
}) => {
  const influencerCampaign = FlashSaleCampaignName.FLASH_SALE_CERTIFICATIONS_2025;
  const theme = useTheme();
  const {
    pathname
  } = useLocation();
  const isCertificationsPage = pathname.includes('/certifications');
  const isOnboardingPage = pathname.includes('/onboarding');
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const {
    data: campaigns
  } = useGetInfluencersCampaignsQuery({
    page: 1,
    limit: 1,
    name: influencerCampaign
  });
  const campaignData = campaigns?.data?.docs[0];
  const campaignConfigs = useInfluencerSubscriptionCampaign(influencerCampaign, campaignData);
  const additionalConfigs = useInfluencerConfigs(campaignData);
  if (!campaignConfigs || !additionalConfigs) return null;
  const {
    campaign,
    isInCurrentInfluencerSession
  } = campaignConfigs;
  const {
    urlToNavigate,
    percentageOff
  } = additionalConfigs;
  const url = userDataResponse?.data ? '/certifications' : urlToNavigate;
  const getCopy = () => {
    if (isOnboardingPage) {
      return <>
          <span>{!isPremium ? percentageOff : 40}% off</span> certifications - Finish onboarding to activate your offer.
        </>;
    }
    if (!isCertificationsPage) {
      return <>
          <span>{!isPremium ? percentageOff : 40}% off</span> certifications - prove your skills and get hired faster.
        </>;
    }
    return <>Offer ends in: </>;
  };
  if (!campaign) return null;
  return !!isInCurrentInfluencerSession && !!campaignData ? <ThemeProvider theme={{
    ...theme,
    colors: lightColors
  }}>
      <StyledBar isEmbedded={isEmbedded} role="region" aria-label="Flash Sale Special Offer">
        <StyledCopyWrapper>
          <p data-testid="campaign-promotion-text">{getCopy()}</p>
        </StyledCopyWrapper>
        <StyledWrapRow>
          {!hideCTA && !isOnboardingPage && !isCertificationsPage && <SubscribeButton to={url} aria-label="Get certified">
              Get certified
            </SubscribeButton>}
          <Countdown vertical dark includeDays endTime={campaign.endTime} />
        </StyledWrapRow>
      </StyledBar>
    </ThemeProvider> : null;
};